var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Backbone from "backbone";
import Asset from "js/lib/asset";
import { MessageChoice, FileChoice, FilesChoice } from "js/lib/choice";
import locale from "js/lib/locale";
// keeps the application state and signals changes with events
var Controller = /** @class */ (function (_super) {
    __extends(Controller, _super);
    function Controller() {
        var _this = _super.call(this) || this;
        _this.asset = null;
        return _this;
    }
    Controller.prototype.setChoice = function (choice) {
        this.set("choice", choice);
    };
    Controller.prototype.useAsset = function (assetId, options) {
        var _this = this;
        if (assetId === "")
            return this.setChoice(new MessageChoice(locale.needsAsset));
        // if we had an asset before, remove the listeners
        if (this.asset)
            this.asset.off();
        console.info("got assetId", assetId);
        var asset = new Asset({ sid: assetId }, options);
        this.asset = asset;
        asset.on("error", function () {
            if (asset.status == 404) {
                _this.setChoice(new MessageChoice(locale.notExists));
            }
        });
        asset.on("change", function () {
            console.log("asset changed attributes:", asset.changedAttributes());
            var choice = asset.getChoice();
            var lastChoice = _this.get("choice");
            // refresh player
            if (choice && JSON.stringify(choice) !== JSON.stringify(lastChoice)) {
                _this.setChoice(choice);
            }
            // Stop polling for protected assets
            // because they receive a new URL on every update
            if (asset.isProtected()) {
                asset.stopPolling();
                console.log("Stopping polling because asset is protected");
            }
        });
        asset.startPolling();
    };
    // decide what to do based on params
    Controller.prototype.configure = function (params) {
        this.params = params;
        // Store settings
        if (params.color)
            this.set("color", params.color);
        if (params.background)
            this.set("background", params.background);
        if (params.t)
            this.set("startTime", params.t);
        if (params.volume)
            this.set("volume", params.volume);
        // Start asset fetching
        if (params.sid) {
            this.useAsset(params.sid, params);
            // Playback a hls stream
        }
        else if (params.stream_name) {
            var name_1 = params.stream_name;
            var url = void 0;
            if (name_1 === "istuff_live") {
                url = "https://cdn.fem-net.de/r/hls/loop/istuff_live/master.m3u8";
            }
            else {
                url = "https://cdn.fem-net.de/r/hls/live/".concat(name_1, "/master.m3u8");
            }
            this.setChoice(new FileChoice(url, undefined, params.image, "application/vnd.apple.mpegurl"));
        }
        else if (params.stream_name_dash) {
            var name_2 = params.stream_name_dash;
            var url = void 0;
            if (name_2 === "istuff_live") {
                url = "https://cdn.fem-net.de/r/dash/loop/istuff_live/manifest.mpd";
            }
            else {
                url = "https://cdn.fem-net.de/r/dash/live/".concat(name_2, "/manifest.mpd");
            }
            this.setChoice(new FileChoice(url, undefined, params.image, "application/dash+xml"));
            // Playback a file
        }
        else if (params.url && typeof params.url === "string") {
            this.setChoice(new FileChoice(params.url, undefined, params.image));
            // Playback file with optional fallbacks
        }
        else if (params.url && params.type && params.url.length &&
            params.url.length === params.type.length) {
            var sources = [];
            for (var i = 0; i < params.url.length; i++) {
                if (params.type[i])
                    sources.push({ src: params.url[i], type: params.type[i] });
            }
            this.setChoice(new FilesChoice(sources, params.image));
        }
        else {
            this.setChoice(new MessageChoice(locale.needsUrl));
        }
    };
    return Controller;
}(Backbone.Model));
export default Controller;
